import { RoutesState } from "./Routes-State";

export default function RoutesReducer (state = RoutesState, action )
{
  switch( action.type )
  {
    default: return state;
  }
}